<script>

import ListingsChartHover from './ListingsChartHover';

export default {
  components: { ListingsChartHover },
  data() {
    return {
      loading: true,
      cur_month: '',
      listings: [],
      filters: {
        selects: [
          'id',
          'StandardStatus',
          'Address',
          'City',
          'StateOrProvince',
          'PostalCode',
          'ListingContractDate',
          'PendingTimestamp',
          'CloseDate',
          'ExpirationDate',
          'CancellationDate',
          'created_at',
          'packages_total',
          'estimated_total',
          'mls_title',
          'active_package',
          'active_services',
          'ListingId',
          'mls_updated_at',
        ],
        whereins: {
          website: [],
        },
        // withs: { carts: { total: 0, wheres: { status: 3, }, orderbys: { paid_date: 'asc', }, }, },
        notins: { StandardStatus: ['Trash'], },
      },
    }
  },
  computed: {
    month_results: function() {
      var results = {
        start: this.moment(this.cur_month).startOf('month').startOf('day'),
        end: this.moment(this.cur_month).endOf('month').endOf('day'),
        awaiting: [],
        active: [],
        pending: [],
        closed: [],
        expired: [],
        cancelled: [],
        weeks: [],
        totals: {
          start: this.moment(this.cur_month).startOf('year').startOf('day'),
          end: this.moment(this.cur_month).endOf('year').endOf('day'),
          awaiting: [],
          active: [],
          pending: [],
          closed: [],
          expired: [],
          cancelled: [],
        },
      },
      // month_weeks = Math.round(this.moment.duration(results.end - results.start).asWeeks() + 1),
      date = this.moment(this.cur_month).startOf('month').startOf('day'),
      i = 0,
      max = 6;

      while(max--){
        if(i > 1 && !this.moment(date).startOf('week').isSame(this.moment(results.start), 'month')) { break; }
        results.weeks[i] = {
          start: this.moment(date).startOf('week').startOf('day'),
          end: this.moment(date).endOf('week').endOf('day'),
          awaiting: [],
          active: [],
          pending: [],
          closed: [],
          expired: [],
          cancelled: [],
        };
        date.add(1, 'week');
        i++;
      }
      // console.log(results.start);

      for(var i in this.listings){
        this.setData(this.listings[i], results);
        this.setData(this.listings[i], results.totals);
        for(var j in results.weeks){
          this.setData(this.listings[i], results.weeks[j]);
        }
      }

      return results;
    },
  },
  created() {
    this.filters.whereins.website = [this.website_id];
    this.cur_month = this.moment();
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/listings/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        for(var i in res.data.data) {
          if(!res.data.data[i].active_services){ res.data.data[i].active_services = []; }
          if(res.data.data[i].active_services && typeof res.data.data[i].active_services === 'object'){ res.data.data[i].active_services = Object.values(res.data.data[i].active_services); }
        }
        this.listings = res.data.data;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    setData(listing, location) {
      if([
        'Awaiting Order',
        'Awaiting Forms',
        'Awaiting Photos',
        'Awaiting Signatures',
        'Awaiting Listing',
      ].includes(listing.StandardStatus) && this.moment(listing.created_at).isBetween(location.start, location.end, null, '[]')){
        location.awaiting.push(listing);
      }
      if(listing.ListingContractDate && this.moment(listing.ListingContractDate).isBetween(location.start, location.end, null, '[]')){
        location.active.push(listing);
      }
      if(listing.PendingTimestamp && this.moment(listing.PendingTimestamp).isBetween(location.start, location.end, null, '[]')){
        location.pending.push(listing);
      }
      if(listing.CloseDate && this.moment(listing.CloseDate).isBetween(location.start, location.end, null, '[]')){
        location.closed.push(listing);
      }
      if(listing.ExpirationDate && this.moment(listing.ExpirationDate).isBetween(location.start, location.end, null, '[]')){
        location.expired.push(listing);
      }
      if(listing.CancellationDate && this.moment(listing.CancellationDate).isBetween(location.start, location.end, null, '[]')){
        location.cancelled.push(listing);
      }
    }
  }
}
</script>

<template>
  <div class="card-box p-0 position-relative" id="print-listings_count_chart">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="p-3">
      <div class="float-right">
        <div class="ml-2">
          <w-field SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="fetchData()" :Disabled="loading"></w-field>
        </div>
        <button type="button" class="btn btn-light ml-2" @click="cur_month = moment()">Today</button>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-light ml-2" @click="cur_month = moment(cur_month).subtract(1, 'month')"><Icon icon="ri:arrow-left-s-line" /></button>
          <button type="button" class="btn btn-light " @click="cur_month = moment(cur_month).add(1, 'month')"><Icon icon="ri:arrow-right-s-line" /></button>
        </div>
        <button type="button" class="btn btn-light ml-2 print_target" target="print-listings_count_chart" v-tippy content="Print chart"><Icon icon="ri:printer-line" /></button>
      </div>
      <h4 class="header-title"><Icon icon="ri:home-2-line" /> Listings Report</h4>
      <p class="m-0 small">Listings are placed into columns by date. If the listing does not have the corresponding date it will not be appear in the collumn.</p>
    </div>
    <table class="table table-sm table-hover m-0 small">
      <thead>
        <tr>
          <th class="border-0 bg-light font-weight-bold">{{moment(cur_month).format('MMMM')}} {{moment(cur_month).format('YYYY')}}</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="All listings in Awaiting Order, Awaiting Forms, Awaiting Photos, Awaiting Signatures or Awaiting Listing stage. Filtered by Created Date.">Awaiting</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="All listings active on the MLS filtered by List Date.">Active</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="All listings pending on the MLS filtered by Pending Date.">Pending</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="All listings closed on the MLS filtered by Sold Date.">Closed</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="All listings expired on the MLS filtered by Expired Date.">Expired</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="All listings cancelled on the MLS filtered by Cancelled Date.">Cancelled</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in month_results.weeks" :key="index">
          <th class="align-middle font-weight-bold py-1">Week {{index+1}} <div class="small font-weight-normal">{{moment(item.start).format('MM-DD-YYYY')}} - {{moment(item.end).format('MM-DD-YYYY')}}</div></th>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{item.awaiting.length}}</div>
            <div v-if="item.awaiting.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.awaiting"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{item.active.length}}</div>
            <div v-if="item.active.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.active"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{item.pending.length}}</div>
            <div v-if="item.pending.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.pending"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{item.closed.length}}</div>
            <div v-if="item.closed.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.closed"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{item.expired.length}}</div>
            <div v-if="item.expired.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.expired"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{item.cancelled.length}}</div>
            <div v-if="item.cancelled.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.cancelled"></ListingsChartHover>
            </div>
          </td>
        </tr>
        <tr>
          <th class="align-middle bg-primary text-white py-1">Month <div class="small">{{moment(month_results.start).format('MM-DD-YYYY')}} - {{moment(month_results.end).format('MM-DD-YYYY')}}</div></th>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.awaiting.length}}</div>
            <div v-if="month_results.awaiting.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.awaiting"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.active.length}}</div>
            <div v-if="month_results.active.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.active"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.pending.length}}</div>
            <div v-if="month_results.pending.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.pending"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.closed.length}}</div>
            <div v-if="month_results.closed.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.closed"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.expired.length}}</div>
            <div v-if="month_results.expired.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.expired"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.cancelled.length}}</div>
            <div v-if="month_results.cancelled.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.cancelled"></ListingsChartHover>
            </div>
          </td>
        </tr>
        <tr>
          <th class="align-middle bg-success text-white py-1">Year <div class="small">{{moment(month_results.totals.start).format('MM-DD-YYYY')}} - {{moment(month_results.totals.end).format('MM-DD-YYYY')}}</div></th>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.totals.awaiting.length}}</div>
            <div v-if="month_results.totals.awaiting.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.awaiting"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.totals.active.length}}</div>
            <div v-if="month_results.totals.active.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.active"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.totals.pending.length}}</div>
            <div v-if="month_results.totals.pending.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.pending"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.totals.closed.length}}</div>
            <div v-if="month_results.totals.closed.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.closed"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.totals.expired.length}}</div>
            <div v-if="month_results.totals.expired.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.expired"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">{{month_results.totals.cancelled.length}}</div>
            <div v-if="month_results.totals.cancelled.length" class="dropdown-menu dropdown-menu-right fade mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.cancelled"></ListingsChartHover>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>
